import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { ref } from "vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'confirm-start-examination-dialog',
  props: {
    isVisible: { type: Boolean }
  },
  emits: {
  "on-close": () => true,
  "on-continue": () => true,
},
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
}





const onClose = () => {
  emit("on-close");
};

const onContinue = () => {
  emit("on-continue");
};

// const

const loading = ref(false);

return { __sfc: true,props, emit, onClose, onContinue, loading, BaseDialog }
}

})